<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Blog',

    metaInfo: { title: 'Blog' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'platform-support',
        // 'customer-reviews',
        // 'we-help-your-success',
        // 'info-graph',
        // 'theme-features',
        // 'affiliates',
        'blog',
        // 'newsletter',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'blog',
      },
    },
  }
</script>
